import React, { useState } from 'react';
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

import ButtonSwitcher from 'components/elements/buttons/ButtonSwitcher';

import './CommonImageSliderShowAs.css';


function CommonImageSliderShowAs(props) {
  const { item, patchImageSlider } = props;
  const { t } = useTranslation();

  const [currentMode, setCurrentMode] = useState(item.display_type);

  const onPatch = value => {
    const form = new FormData();
    form.append('display_type', value);
    patchImageSlider(item.id, form);
  };

  const buttonsList = [
    {
      buttonName: t('Show as slider'),
      executeFunc: () => {
        setCurrentMode('show_as_slider');
        onPatch('show_as_slider');
      },
      checked: currentMode === 'show_as_slider',
      buttonIcon: 'slider',
    },
    {
      buttonName: t('Show as grid'),
      executeFunc: () => {
        setCurrentMode('show_as_grid');
        onPatch('show_as_grid');
      },
      checked: currentMode === 'show_as_grid',
      buttonIcon: 'grid',
    },
  ];

  return (
    <div className="common-image-slider-show-as__component">
      <ButtonSwitcher
        buttonsList={buttonsList}
        // buttonWidth={140}
      />
    </div>
  );
}

CommonImageSliderShowAs.propTypes = {
  patchImageSlider: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default CommonImageSliderShowAs;
